module.exports = __webpack_public_path__ + "img/MapPicsPersianQuarries.32771e3a.webp";